import React, { forwardRef } from 'react'
import { ReactComponent as EmptySVG } from './emptyNone.svg'

export const EmptyNoneIcon = forwardRef<SVGSVGElement, React.PropsWithChildren<{}>>((props, ref) => {
  return <EmptySVG ref={ref} {...props} />
})
